import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReceiptsLeftActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  padding-right: ${Spacing.S24};
`
